"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _readExcelFile = _interopRequireDefault(require("read-excel-file"));
var _reactPapaparse = require("react-papaparse");
var _uuid = require("uuid");
var _mimeTypes = _interopRequireDefault(require("mime-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _FileLoader = _interopRequireDefault(require("../../common/FileLoader"));
var _FileUploaderFile = _interopRequireDefault(require("./FileUploaderFile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = "/**\n * Not using carbon's productive-heading-xx:\n * - They can't be imported into SCSS files of components with \"@include carbon--type-style('productive-heading-04')\",\n *   the rules are not being applied. Even if applied into the theme, and after importing\n *   '@carbon/type/scss/styles' and '@carbon/themes/scss/tokens'.\n * - They are confusing because they are defined in opposite order of h1, h2, etc.\n * todo SW-122. cleanup productive-heading-xx\n */\nh1 {\n  font-family: 'LettrGoth12 BT W05 Regular', Arial;\n  font-size: 32px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #000000;\n  margin-bottom: 24px;\n  padding-right: 16px; }\n\nh2 {\n  font-family: 'LettrGoth12 BT W05 Regular', Arial;\n  font-size: 28px;\n  line-height: 32px;\n  margin-bottom: 24px;\n  color: #000000; }\n\nh3 {\n  font-family: Helvetica, Arial;\n  font-size: 20px;\n  line-height: 26px;\n  margin-bottom: 18px;\n  color: #000000; }\n\n.productive-heading-01 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.28572;\n  letter-spacing: 0.16px; }\n\n.productive-heading-02 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.375;\n  letter-spacing: 0; }\n\n.productive-heading-03 {\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: 0; }\n\n.productive-heading-04 {\n  font-size: 1.75rem;\n  font-weight: 400;\n  line-height: 1.28572;\n  letter-spacing: 0;\n  /**\n   * todo #0537, line-height definition \"line-height: 32px\" in the theme map merge, is somehow parsed as\n   * \"line-height: var(--cds-productive-heading-04-line-height, 32px);\" which somehow finally results as\n   * \"line-height: 1.29\". 1.29 is not the same as 32px, but the designer wants 32px.\n   */\n  line-height: 32px; }\n\n.productive-heading-05 {\n  font-size: 2rem;\n  font-weight: 400;\n  line-height: 1.25;\n  letter-spacing: 0; }\n\n.productive-heading-06 {\n  font-size: 2.625rem;\n  font-weight: 300;\n  line-height: 1.199;\n  letter-spacing: 0; }\n\n.productive-heading-07 {\n  font-size: 3.375rem;\n  font-weight: 300;\n  line-height: 1.19;\n  letter-spacing: 0; }\n\n/**\n * Example use case \"body-short-01-text-02\":\n * Zeplin says \"body-short-01 / text-02\". carbon--type-style() does not find \"body-short-01-text-02\".\n * Adding \"body-short-01-text-02\" in siatheme.scss in this overengineered concept with map-merge does not\n * fix this. So we simply make a mixin for it.\n */\n.file-uploader {\n  margin-bottom: 1.5rem; }\n  .file-uploader.disabled {\n    opacity: 0.3; }\n  .file-uploader .bx--label {\n    color: #4c4c4c; }\n  .file-uploader .bx--file--label,\n  .file-uploader .bx--label-description {\n    display: none; }\n  .file-uploader .description {\n    font-family: Helvetica, Arial;\n    font-size: 16px;\n    line-height: 18px;\n    letter-spacing: 0.18px;\n    display: block;\n    margin-bottom: 11px; }\n  .file-uploader .bx--btn {\n    padding-right: 1rem; }\n  .file-uploader .bx--btn--secondary {\n    border-color: #4c4c4c;\n    color: #4c4c4c;\n    background: white; }\n    .file-uploader .bx--btn--secondary:hover {\n      background: #d4d4d4; }\n    .file-uploader .bx--btn--secondary[disabled] {\n      color: #a8a8a8;\n      border-color: #d4d4d4; }\n      .file-uploader .bx--btn--secondary[disabled]:hover {\n        color: #8d8d8d;\n        border-color: #c6c6c6; }\n    .file-uploader .bx--btn--secondary.bx--btn--md {\n      padding: 11px 16px;\n      min-height: 48px; }\n  .file-uploader .bx--file-container {\n    display: none; }\n  .file-uploader .files {\n    margin: 11px 0 0 0;\n    width: fit-content; }\n    .file-uploader .files .bx--file__selected-file {\n      background: none;\n      min-height: initial; }\n      .file-uploader .files .bx--file__selected-file .bx--file-filename {\n        margin: 0; }\n      .file-uploader .files .bx--file__selected-file .bx--file-close {\n        height: auto; }\n  .file-uploader .bx--file .bx--file-browse-btn {\n    max-width: initial; }\n  .file-uploader .bx--file .bx--file__drop-container {\n    line-height: 18px;\n    border-color: #4c4c4c; }\n  .file-uploader .bx--file .bx--file-browse-btn--disabled {\n    color: #4c4c4c;\n    outline: 0; }\n  .file-uploader .bx--form-requirement {\n    display: block;\n    max-height: initial;\n    color: #e41b13; }\n";
  const fileName = "FileUploader_FileUploader";
  const element = document.querySelector("style[data-sass-component='FileUploader_FileUploader']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const FileUploader = props => {
  const {
    readRemoteFile
  } = (0, _reactPapaparse.usePapaParse)();
  const parseExcel = props.parseExcel;
  const fileTypesTranslationKey = props.fileTypes.length === 1 ? 'file-uploader.description.file-types.singular' : 'file-uploader.description.file-types.plural';
  const dottedFileTypes = props.fileTypes.map(value => `.${value}`);
  const allowedMediaTypes = props.fileTypes.map(value => _mimeTypes.default.lookup(value));
  const descriptions = [props.translate('file-uploader.description.size-limit', {
    sizeLimit: `${props.sizeLimit}${props.sizeLimitUnit}`
  }), props.translate(fileTypesTranslationKey, {
    fileTypes: dottedFileTypes.join(', ')
  }), props.translate(props.additionalDescription)];
  const getBytesFromSizeLimit = () => {
    switch (props.sizeLimitUnit) {
      case 'MB':
        return props.sizeLimit * 1024 * 1024;
      case 'KB':
        return props.sizeLimit * 1024;
    }
  };
  const isAnyFileTooBig = eventFiles => {
    for (let i = 0; i < eventFiles.length; i++) {
      const file = eventFiles[i];
      const isTooBig = file.size > getBytesFromSizeLimit();
      if (isTooBig) {
        return true;
      }
    }
  };
  const getErrorMessage = eventFiles => {
    return isAnyFileTooBig(eventFiles) ? 'file-uploader.error.too-big' : null;
  };
  const onChange = (event, eventFiles) => {
    if (parseExcel) {
      return handleFileChange(event, eventFiles);
    }
    const allowedEventFiles = Array.from(eventFiles).filter(eventFile => allowedMediaTypes.includes(eventFile.type));
    const files = [];
    allowedEventFiles.forEach((eventFile, index) => {
      const sequence = index + 1;
      const isLast = allowedEventFiles.length === sequence;
      const base64Promise = _FileLoader.default.loadBase64(eventFile);
      base64Promise.then(base64 => {
        files.push(new _FileUploaderFile.default((0, _uuid.v4)(), eventFile, base64));
        if (isLast) {
          props.onChange(event, files, getErrorMessage(eventFiles));
        }
      });
    });
  };
  const handleFileChange = async function (event) {
    let eventFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const file = eventFiles && eventFiles.length > 0 ? eventFiles[0] : event.target.files[0];
    let rows = [];
    try {
      if (file.type.includes('csv')) {
        await readRemoteFile(file, {
          step: row => {
            rows.push(row.data);
          },
          complete: () => {
            props.onChange(event, rows, null);
          }
        });
      } else {
        rows = await (0, _readExcelFile.default)(file, {
          sheet: 1
        });
        props.onChange(event, rows, null);
      }
    } catch (error) {
      console.error('Error reading excel file:', error);
      props.onChange(event, [], error);
    }
  };
  const onRemove = (event, removingFile) => {
    const updatedFiles = props.files.filter(currentFile => currentFile.getId() !== removingFile.getId());
    const errorMessage = getErrorMessage(updatedFiles);
    props.onRemove(event, removingFile, updatedFiles, errorMessage);
  };
  const classes = ['file-uploader', props.disabled ? 'disabled' : null];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, props.label && /*#__PURE__*/_react.default.createElement("label", {
    className: "bx--label"
  }, props.translate(props.label)), /*#__PURE__*/_react.default.createElement("label", {
    className: "description"
  }, descriptions.join(' ')), !props.draggable && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.FileUploader, {
    buttonKind: "secondary",
    buttonLabel: props.translate(props.buttonLabel),
    accept: dottedFileTypes,
    filenameStatus: "edit",
    onChange: event => onChange(event, event.target.files),
    multiple: props.multiple
  }), props.draggable && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.FileUploaderDropContainer, {
    labelText: props.translate('file-uploader.description.drop-area'),
    accept: dottedFileTypes,
    onAddFiles: (event, data) => {
      const eventFiles = data.addedFiles.filter(eventFile => {
        const fileExtension = eventFile.name.split('.').pop();
        return props.fileTypes.includes(fileExtension.toLowerCase());
      });
      onChange(event, eventFiles);
    },
    multiple: props.multiple,
    disabled: props.disabled
  }), !props.customList && props.files && Boolean(props.files.length) && /*#__PURE__*/_react.default.createElement("div", {
    className: 'files'
  }, props.files.map(file => /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.FileUploaderItem, {
    key: file.getId(),
    status: 'edit',
    name: file.getName(),
    onDelete: event => onRemove(event, file)
  }))), props.invalidText && /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--form-requirement'
  }, props.translate(props.invalidText)));
};
FileUploader.propTypes = {
  sizeLimit: _propTypes.default.number.isRequired,
  sizeLimitUnit: _propTypes.default.string.isRequired,
  fileTypes: _propTypes.default.array.isRequired,
  translate: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  /** @var {FileUploaderFile}[] files **/
  files: _propTypes.default.array,
  onRemove: _propTypes.default.func,
  label: _propTypes.default.string,
  buttonLabel: _propTypes.default.string,
  draggable: _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  additionalDescription: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  invalidText: _propTypes.default.string,
  customList: _propTypes.default.bool
};
var _default = exports.default = FileUploader;